import { render, staticRenderFns } from "./activitys.vue?vue&type=template&id=c734c908&scoped=true&"
import script from "./activitys.vue?vue&type=script&lang=js&"
export * from "./activitys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c734c908",
  null
  
)

export default component.exports